(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rw-athletes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.rwReady) return;
      root.dataset.rwReady = '1';
      var dlg = root.querySelector('[data-rw-dialog]');
      if (!dlg) return;
      var media = dlg.querySelector('[data-rw-dlg-media]');
      var nameEl = dlg.querySelector('[data-rw-dlg-name]');
      var roleEl = dlg.querySelector('[data-rw-dlg-role]');
      var bioEl = dlg.querySelector('[data-rw-dlg-bio]');
      var igEl = dlg.querySelector('[data-rw-dlg-ig]');
      var igText = dlg.querySelector('[data-rw-dlg-ig-text]');
      var opener = null;

      var cards = root.querySelectorAll('[data-rw-person]');
      var empty = root.querySelector('[data-rw-aempty]');
      root.querySelectorAll('[data-rw-afilter]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var f = btn.dataset.rwAfilter, shown = 0;
          root.querySelectorAll('[data-rw-afilter]').forEach(function (b) {
            b.classList.toggle('is-active', b === btn); b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
          cards.forEach(function (c) {
            var hide = f !== 'all' && c.dataset.type !== f;
            c.classList.toggle('is-filtered', hide);
            if (!hide) shown++;
          });
          if (empty) empty.hidden = shown > 0;
        });
      });

      function close() {
        if (dlg.close) dlg.close(); else dlg.removeAttribute('open');
      }
      dlg.addEventListener('close', function () {
        document.documentElement.classList.remove('rw-at-lock');
        if (opener) { opener.focus(); opener = null; }
      });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
      dlg.querySelector('[data-rw-close]').addEventListener('click', close);

      root.querySelectorAll('[data-rw-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var p = btn.closest('[data-rw-person]');
          if (!p) return;
          opener = btn;
          nameEl.textContent = p.dataset.name || '';
          roleEl.textContent = p.dataset.role || '';
          roleEl.hidden = !p.dataset.role;
          media.textContent = '';
          if (p.dataset.img) {
            var img = new Image();
            img.src = p.dataset.img;
            img.alt = p.dataset.name || '';
            media.appendChild(img);
          } else {
            var ph = p.querySelector('.rw-at__ph');
            if (ph) media.appendChild(ph.cloneNode(true));
          }
          bioEl.textContent = '';
          var tpl = p.querySelector('template[data-rw-bio]');
          if (tpl) bioEl.appendChild(tpl.content.cloneNode(true));
          if (igEl) {
            var ig = p.dataset.ig || '';
            igEl.hidden = !ig;
            if (ig) {
              igEl.href = 'https://www.instagram.com/' + encodeURIComponent(ig) + '/';
              igText.textContent = '@' + ig;
              igEl.setAttribute('aria-label', 'Instagram: @' + ig + ' (opens in a new tab)');
            }
          }
          bioEl.scrollTop = 0;
          document.documentElement.classList.add('rw-at-lock');
          if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
        });
      });
    }
    function boot() { document.querySelectorAll('[data-rw-athletes]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-rw-athletes]')); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rw-leadership"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.rwReady) return;
      root.dataset.rwReady = '1';
      var dlg = root.querySelector('[data-rw-dialog]');
      if (!dlg) return;
      var media = dlg.querySelector('[data-rw-dlg-media]');
      var nameEl = dlg.querySelector('[data-rw-dlg-name]');
      var roleEl = dlg.querySelector('[data-rw-dlg-role]');
      var bioEl = dlg.querySelector('[data-rw-dlg-bio]');
      var opener = null;

      function close() {
        if (dlg.close) dlg.close(); else dlg.removeAttribute('open');
      }
      dlg.addEventListener('close', function () {
        document.documentElement.classList.remove('rw-ld-lock');
        if (opener) { opener.focus(); opener = null; }
      });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
      dlg.querySelector('[data-rw-close]').addEventListener('click', close);

      root.querySelectorAll('[data-rw-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var p = btn.closest('[data-rw-person]');
          if (!p) return;
          opener = btn;
          nameEl.textContent = p.dataset.name || '';
          roleEl.textContent = p.dataset.role || '';
          roleEl.hidden = !p.dataset.role;
          media.textContent = '';
          if (p.dataset.img) {
            var img = new Image();
            img.src = p.dataset.img;
            img.alt = p.dataset.name || '';
            media.appendChild(img);
          } else {
            var ph = p.querySelector('.rw-ld__ph');
            if (ph) media.appendChild(ph.cloneNode(true));
          }
          bioEl.textContent = '';
          var tpl = p.querySelector('template[data-rw-bio]');
          if (tpl) bioEl.appendChild(tpl.content.cloneNode(true));
          bioEl.scrollTop = 0;
          document.documentElement.classList.add('rw-ld-lock');
          if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
        });
      });
    }
    function boot() { document.querySelectorAll('[data-rw-leadership]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-rw-leadership]')); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rw-organizations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.rwReady) return;
      root.dataset.rwReady = '1';
      var cards = root.querySelectorAll('[data-rw-org]');
      var empty = root.querySelector('[data-rw-oempty]');
      root.querySelectorAll('[data-rw-ofilter]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var f = btn.dataset.rwOfilter, shown = 0;
          root.querySelectorAll('[data-rw-ofilter]').forEach(function (b) {
            b.classList.toggle('is-active', b === btn); b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
          cards.forEach(function (c) {
            var hide = f !== 'all' && c.dataset.type !== f;
            c.classList.toggle('is-filtered', hide);
            if (!hide) shown++;
          });
          if (empty) empty.hidden = shown > 0;
        });
      });
    }
    function boot() { document.querySelectorAll('[data-rw-orgs]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-rw-orgs]')); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rw-patents"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.rwReady) return;
      root.dataset.rwReady = '1';
      var cards = root.querySelectorAll('[data-rw-patent]');
      root.querySelectorAll('[data-rw-pfilter]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var f = btn.dataset.rwPfilter;
          root.querySelectorAll('[data-rw-pfilter]').forEach(function (b) {
            b.classList.toggle('is-active', b === btn); b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
          var shown = 0;
          cards.forEach(function (c) {
            var hide = f !== 'all' && c.dataset.type !== f;
            c.classList.toggle('is-filtered', hide);
            if (!hide) shown++;
          });
          var empty = root.querySelector('[data-rw-pempty]');
          if (empty) empty.hidden = shown > 0;
        });
      });
    }
    function boot() { document.querySelectorAll('[data-rw-patents]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-rw-patents]')); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rw-season-timeline"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MONTHS = ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];

    function parts(date, tz) {
      var p = {};
      try {
        new Intl.DateTimeFormat('en-CA', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
          .formatToParts(date).forEach(function (x) { p[x.type] = x.value; });
      } catch (e) {
        return parts(date, 'America/New_York');
      }
      return { date: p.year + '-' + p.month + '-' + p.day, time: p.hour + ':' + p.minute };
    }
    function zonedToUtc(ymd, hm, tz) {
      var a = ymd.split('-').map(Number), b = (hm || '00:00').split(':').map(Number);
      var target = Date.UTC(a[0], a[1] - 1, a[2], b[0], b[1]);
      var guess = target;
      for (var i = 0; i < 3; i++) {
        var q = parts(new Date(guess), tz), qa = q.date.split('-').map(Number), qb = q.time.split(':').map(Number);
        guess += target - Date.UTC(qa[0], qa[1] - 1, qa[2], qb[0], qb[1]);
      }
      return new Date(guess);
    }
    function dayDiff(from, to) { return Math.round((Date.parse(to + 'T00:00:00Z') - Date.parse(from + 'T00:00:00Z')) / 86400000); }
    function fmt(hm) { var t = hm.split(':').map(Number); return (t[0] % 12 || 12) + ':' + String(t[1]).padStart(2, '0') + ' ' + (t[0] >= 12 ? 'PM' : 'AM'); }
    function schedule(card) {
      try { var j = JSON.parse(card.querySelector('[data-rw-schedule]').textContent || 'null'); return (j && j.days) || []; } catch (e) { return []; }
    }
    function icsEsc(s) { return String(s || '').replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\r?\n/g, '\\n'); }
    function icsUtc(d) { return d.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, ''); }
    function icsDate(ymd) { return ymd.replace(/-/g, ''); }
    function nextDay(ymd) { var d = new Date(ymd + 'T00:00:00Z'); d.setUTCDate(d.getUTCDate() + 1); return d.toISOString().slice(0, 10); }

    function downloadIcs(card) {
      var c = card.dataset, tz = c.tz, days = schedule(card), lines = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Roswell Marine//Events//EN', 'CALSCALE:GREGORIAN', 'METHOD:PUBLISH'];
      var desc = (c.booth ? ((card.closest('[data-rw-timeline]') || card).dataset.boothLabel || 'Booth') + ' ' + c.booth + '\n' : '') + (c.schedText ? c.schedText + '\n' : '') + (c.url || '');
      var stamp = icsUtc(new Date());
      var list = days.filter(function (d) { return !d.closed; });
      var anyHours = list.some(function (d) { return d.open; });
      if (!list.length || !anyHours) list = [{ date: c.start, open: null, close: null, end: c.end, note: null }];
      list.forEach(function (d) {
        lines.push('BEGIN:VEVENT', 'UID:' + c.handle + '-' + d.date + '@roswellmarine.com', 'DTSTAMP:' + stamp);
        if (d.open && d.close) {
          lines.push('DTSTART:' + icsUtc(zonedToUtc(d.date, d.open, tz)), 'DTEND:' + icsUtc(zonedToUtc(d.date, d.close, tz)));
        } else {
          lines.push('DTSTART;VALUE=DATE:' + icsDate(d.date), 'DTEND;VALUE=DATE:' + icsDate(nextDay(d.end || d.date)));
        }
        lines.push('SUMMARY:' + icsEsc(c.title + (d.note ? ' (' + d.note + ')' : '')), 'LOCATION:' + icsEsc(c.location), 'DESCRIPTION:' + icsEsc(desc));
        if (c.url) lines.push('URL:' + c.url);
        lines.push('END:VEVENT');
      });
      lines.push('END:VCALENDAR');
      var blob = new Blob([lines.join('\r\n')], { type: 'text/calendar;charset=utf-8' });
      var a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = (c.handle || 'event') + '.ics';
      document.body.appendChild(a); a.click();
      setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 1000);
    }

    function init(root) {
      if (!root || root.dataset.rwReady) return;
      root.dataset.rwReady = '1';
      var now = new Date();
      var D = root.dataset;
      var L = {
        live: D.liveLabel || 'Live now', next: D.nextLabel || 'Next up',
        days: D.daysLabel || 'In {days} days', tomorrow: D.tomorrowLabel || 'Tomorrow',
        open: D.openLabel || 'Open now · until {time}', opens: D.opensLabel || 'Opens today at {time}',
        closed: D.closedLabel || 'Closed today', done: D.doneLabel || 'Closed for today',
        happening: D.happeningLabel || 'Happening now'
      };
      var ua = navigator.userAgent || '';
      var appleDevice = /iPhone|iPad|iPod|Macintosh/.test(ua);
      var useApple = D.maps === 'apple' || (D.maps === 'auto' && appleDevice);
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-rw-event]'));
      var featured = root.querySelector('[data-rw-featured]');
      var next = null;

      cards.forEach(function (card) {
        var c = card.dataset, today = parts(now, c.tz).date;
        var state = c.end < today ? 'past' : (c.start <= today ? 'live' : 'upcoming');
        card.dataset.state = state;
        if (!next && state !== 'past') next = card;

        var badge = card.querySelector('[data-rw-badge]');
        var todayEl = card.querySelector('[data-rw-today]');
        if (state === 'live') {
          badge.textContent = L.live; badge.hidden = false;
          var d = schedule(card).filter(function (x) { return x.date === today; })[0];
          var t = parts(now, c.tz).time, msg = L.happening;
          if (d && d.closed) msg = L.closed;
          else if (d && d.open && d.close) msg = t < d.open ? L.opens.replace('{time}', fmt(d.open)) : (t < d.close ? L.open.replace('{time}', fmt(d.close)) : L.done);
          else if (d && d.open) msg = t < d.open ? L.opens.replace('{time}', fmt(d.open)) : L.happening;
          todayEl.textContent = msg; todayEl.hidden = false;
          card.querySelectorAll('.rw-tile').forEach(function (tile, i) {
            var sd = schedule(card)[i];
            if (sd && sd.date === today) tile.classList.add('is-today');
          });
        } else if (state === 'upcoming') {
          var n = dayDiff(today, c.start);
          badge.textContent = L.next + ' · ' + (n === 1 ? L.tomorrow : L.days.replace('{days}', n));
        }

        var icsBtn = card.querySelector('[data-rw-ics]');
        if (icsBtn) icsBtn.addEventListener('click', function () { downloadIcs(card); });
        var maps = card.querySelector('[data-rw-maps]');
        if (maps && useApple) maps.href = 'https://maps.apple.com/?q=' + encodeURIComponent(maps.dataset.q || '');
      });

      var featuredCard = null;
      if (next && root.dataset.feature === 'true' && featured) {
        featuredCard = next;
        next.classList.add('is-next');
        next.querySelector('[data-rw-badge]').hidden = false;
        featured.appendChild(next);
      }

      var remaining = cards.filter(function (c) { return c !== featuredCard && c.dataset.state !== 'past'; });
      var later = root.querySelector('[data-rw-later]');
      if (later) later.hidden = remaining.length === 0;
      var empty = root.querySelector('[data-rw-empty]');
      if (empty) empty.hidden = !!next;
      if (later && !featuredCard) later.hidden = !next;

      // Rail: rolling 12 months from the current month.
      var labels = root.querySelectorAll('[data-rw-month]');
      if (labels.length) {
        var base = parts(now, root.dataset.tz).date.split('-').map(Number);
        var baseIdx = base[0] * 12 + (base[1] - 1);
        labels.forEach(function (el, i) {
          var mi = (base[1] - 1 + i) % 12, yr = base[0] + Math.floor((base[1] - 1 + i) / 12);
          el.textContent = MONTHS[mi] + (mi === 0 && i > 0 ? ' ' + String(yr).slice(2) : '');
        });
        var laneEnds = [];
        var bars = Array.prototype.slice.call(root.querySelectorAll('[data-rw-bar]'))
          .sort(function (a, b) { return a.dataset.start < b.dataset.start ? -1 : 1; });
        bars.forEach(function (bar) {
          var s = bar.dataset.start.split('-').map(Number), e = bar.dataset.end.split('-').map(Number);
          var si = s[0] * 12 + (s[1] - 1) - baseIdx, ei = e[0] * 12 + (e[1] - 1) - baseIdx;
          var todayDefault = parts(now, root.dataset.tz).date;
          if (ei < 0 || si > 11 || bar.dataset.end < todayDefault) { bar.hidden = true; return; }
          var from = Math.max(0, si), to = Math.min(11, ei);
          var lane = 0;
          while (laneEnds[lane] !== undefined && laneEnds[lane] >= from) lane++;
          laneEnds[lane] = to;
          bar.style.gridColumn = (from + 1) + ' / ' + (to + 2);
          bar.style.gridRow = String(lane + 1);
          for (var m = from; m <= to; m++) labels[m].classList.add('has-events');
          if (next && bar.getAttribute('href') === '#' + next.id) {
            bar.classList.add('is-next');
            labels[from].classList.add('is-next');
          }
        });
      }

      // Filters
      var home = (root.dataset.home || 'US').toUpperCase();
      root.querySelectorAll('[data-rw-filter]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var f = btn.dataset.rwFilter;
          root.querySelectorAll('[data-rw-filter]').forEach(function (b) {
            b.classList.toggle('is-active', b === btn); b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
          cards.forEach(function (card) {
            if (card === featuredCard) return;
            var cc = (card.dataset.country || '').toUpperCase();
            var hide = (f === 'home' && cc !== home) || (f === 'intl' && cc === home);
            card.classList.toggle('is-filtered', hide);
          });
          root.querySelectorAll('[data-rw-bar]').forEach(function (bar) {
            var cc = (bar.dataset.country || '').toUpperCase();
            bar.style.opacity = ((f === 'home' && cc !== home) || (f === 'intl' && cc === home)) ? '0.25' : '';
          });
        });
      });

      // Past toggle
      var past = root.querySelector('[data-rw-past]');
      if (past) {
        if (!cards.some(function (c) { return c.dataset.state === 'past'; })) past.hidden = true;
        past.addEventListener('click', function () {
          var on = root.classList.toggle('show-past');
          past.setAttribute('aria-expanded', on ? 'true' : 'false');
          past.textContent = on ? past.dataset.hide : past.dataset.show;
        });
      }
    }

    function boot() { document.querySelectorAll('[data-rw-timeline]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-rw-timeline]')); });
  })();

  } catch(e) { console.error(e); }
})();
})();
